import { Component, Input, OnInit } from '@angular/core';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';

@Component({
  selector: 'app-pix-pagina',
  templateUrl: './pix-pagina.component.html',
  styleUrls: ['./pix-pagina.component.css']
})
export class PixPaginaComponent implements OnInit{
  @Input()
  public pixCopiaECola:string;

  constructor(private snackBarManager: SnackbarManager,){}
  
  ngOnInit(): void {
    this.pixCopiaECola = localStorage.getItem("pixCopiaECola");
  }

  copiarCodigo() {
    navigator.clipboard.writeText(this.pixCopiaECola).then(() => {
      this.snackBarManager.openSnackBar('Código PIX copiado para a área de transferência!', 'Ok', 3000);
    });
  }
}
